import { serverBus} from '@/main'
import SessionManager from '@/Manager/Session.manager'
import ChannelApi from './api/channel.api';
import Global from './Global';
import WebRTCConfig from './WebRTC/WebRTCConfig'
import SignalingServer from './WebRTC/SignalingServer';
import VueSignals from './VueSignals';
import Socket from '../classes/WebSocket';
import MainNotification from '../Manager/Notification/main.manager';


export default {
    name: 'CalleePeer',
    data (){
        return {
            loggedInUserId: SessionManager.getLoggedInUserId(),
            callFromUserId: '',
            CallingUser: null,
            callState:'none',
            callChannelId: '',
            callTime: 0,
            elapsedTime:"00:00",
            automaticAnswer: false,
            callerUserId: "",
            microphoneMuted : false,
            allowVideo: false,
            reconnected: false,
            leaderPointer: 0,
            localAudioStream: null,
            localVideoStream: null,
            localVideoStreamType: '',
            fromJoin: false,
            neededTime: 0,
            callUserIds: [],
            pc_rec: null,
            RTCBackupDesc:[],
            RTCBackupConnections: [],
            timeToNotify: 0,
            startMountTime: 0,
            NotifyJoinCallTime: 0,
            joinedAtTime:0,
            sinceNotify: 0,
            calleeAudio:new Audio(`${process.env.BASE_URL}callee-ringtone.mp3`),
            removeForInitatingCall: false,
        }
    },
    computed: {
      isELectron() {
        return Global.isELectron();
      }
    },
    mounted(){
      this.ResetCallData()

      serverBus.$on(VueSignals.LOGGED_IN_USER, () => {
        this.loggedInUserId =  SessionManager.getLoggedInUserId()
      })

      serverBus.$on("RTC_REMOVE_ANSWER", (status) => {
        this.removeForInitatingCall = status
      })

      serverBus.$on("Time_joined_created", (data) => {
        this.startMountTime = new Date().getTime()
      })

      // rejoin after refresh
      serverBus.$on("ongoing_channel_call_id", (data) => {
          if(data.length > 0){
            setTimeout(function(){
              // this.pc_rec = new RTCPeerConnection(WebRTCConfig.stun_turn_servers)
              ChannelApi.join_call(data).then(res=>{
                if(res.data.result){
                    // @TODO check
                    Global.globalValue("Time_joined_created", true)
                }else {

                    }
                  })
              }, 1000)
          }
            // Global.globalValue("ongoing_channel_call_id", "")
        })



        serverBus.$on(VueSignals.SOCKET_USER_STATUS_CHANGED, (result) => {
          if(result.data.status == "offline" ){
              Global.globalValue("CALL_REMOVE_USER", result.data.user_id)
          }


          if(result.data.status == "offline" && this.callFromUserId == result.data.user_id){
              this.DeclineCall()
          }

        })



      serverBus.$on(WebRTCConfig.SOCKET_CALL_TIMEOUT, (data) => {
        if(this.callChannelId == data.channel_id){
          this.callState = "timeout"
          this.DeclineCall()
        }
      })

      //@TODO check if the call is the initator
      serverBus.$on(WebRTCConfig.SOCKET_DECLINE_CALL, (data) => {
        if(this.loggedInUserId == data.creator_user_id ||
            data.creator_user_id == this.callFromUserId){

          this.DeclineCall()
        }
      })


        serverBus.$on("calculateCallTime", () => {
          //@TODO STOP it at end
          if(typeof this.pc_rec != "undefined" && this.pc_rec.iceConnectionState == "connected"){
            this.calculateCallTime()
          }
        })



        serverBus.$on(WebRTCConfig.SOCKET_CREATE_RTC_CALL, (rtcData) => {

            console.log('recieving call from', rtcData.channel_id);
            this.NotifyJoinCallTime = new Date().getTime()
            // this.ResetCallData()
            if(this.loggedInUserId != rtcData.creator_user_id){
              if(!this.automaticAnswer && !rtcData.join){
                this.callState = 'incomingcall'
                MainNotification.push(this.$t("Incoming call from", {user: SessionManager.getUser(rtcData.creator_user_id).username}))
                this.calleeAudio.loop = true
                this.calleeAudio.play()
              }

              this.callFromUserId = rtcData.creator_user_id
              this.CallingUser = SessionManager.getUser(rtcData.creator_user_id)
              this.callChannelId = rtcData.channel_id
              this.pc_rec = new RTCPeerConnection(WebRTCConfig.stun_turn_servers)
              this.callerUserId = rtcData.creator_user_id
              this.callUserIds = rtcData.call_user_ids

              this.pc_rec.onnegotiationneeded = (e) => {
                console.info("***** negotation", e)
              }
              console.log('Created remote peer connection object recieve')

              this.pc_rec.setRemoteDescription(new RTCSessionDescription(rtcData.desc)).then(
                console.log("answer setRemoteDescription complete")
              ).catch((err) => {
                console.log("answer setRemoteDescription Error" + err)
              })

              this.pc_rec.ontrack = (e) => {
                this.track(e, rtcData.creator_user_id)
              }

              this.fromJoin = rtcData.join
              this.RequestMicrophone()
            }
          })



          serverBus.$on(WebRTCConfig.SOCKET_UPGRADE_ANSWER_FROM_CALLER, (rtcData) => {
            if(this.loggedInUserId != rtcData.creator_user_id){
              this.callerUserId = rtcData.creator_user_id
              this.pc_rec.setRemoteDescription(new RTCSessionDescription(rtcData.desc)).then( () => {})
              .catch((err) => {
                    console.log(err)
                    // Global.globalValue(WebRTCConfig.SOCKET_UPGRADE_ANSWER_FROM_CALLER, rtcData)
              })

              this.pc_rec.ontrack = (e) => {
                this.track(e, rtcData.from_user_id)
              }
            }
          })


          serverBus.$on(WebRTCConfig.SOCKET_UPGRADE_CALL, (rtcData) => {
              if(this.loggedInUserId != rtcData.creator_user_id){
              // this.callerUserId = rtcData.data_of_user_id
              if(this.pc_rec != null){
              this.pc_rec.setRemoteDescription( new RTCSessionDescription(rtcData.desc)).then( () => {
                SignalingServer.HaveRecievedUser(this.loggedInUserId,
                                              rtcData.data_of_user_id,
                                              [rtcData.creator_user_id])
                console.log("answer setRemoteDescription complete")
              }).then(() => {
                this.pc_rec.createAnswer().then( answer => {
                  SignalingServer.AnswerCall(this.loggedInUserId,
                                          answer,
                                          true,
                                          [rtcData.creator_user_id])
                  this.pc_rec.setLocalDescription(new RTCSessionDescription(answer))
                  console.log("finish answer")
                }).catch(err => {
                  console.log(err)
                })
              }).catch((err) => {
                /**in case of failure */
                console.log("answer setRemoteDescription Error" + err)
                // Global.globalValue(WebRTCConfig.SOCKET_UPGRADE_CALL, rtcData)
                  let rtcICE =  {"event":"SOCKET_ICE_ERROR",
                    "creator_user_id": this.loggedInUserId,
                    "channel_id": this.callChannelId,
                    "broadcast": {
                      "user_ids": [this.callFromUserId],
                  }}
                  Socket.push(rtcICE)
              })
                this.pc_rec.ontrack = (e) => {
                  this.track(e, rtcData.data_of_user_id)
                }
               }
            }
          })

      serverBus.$on(WebRTCConfig.SOCKET_OFFER_ICE, (rtcData) => {
          if(this.callState == 'accepted' && this.loggedInUserId != rtcData.creator_user_id){
            // this.callChannelId = rtcData.channel_id
            console.log("got an offer ICE")
            let ops = false
            try {
              new RTCIceCandidate(rtcData.candidate)
              ops = true
            } catch (error) {
              ops = false
            }

            if(ops && rtcData.candidate.candidate){
              this.pc_rec.addIceCandidate(new RTCIceCandidate(rtcData.candidate)).then(() => {
                console.log("---------- add ICE success")
              }).catch((err) => {
                console.error("not added candidated " + err)
                // Global.globalValue(WebRTCConfig.SOCKET_OFFER_ICE, rtcData)
              })
            }
          }
      })
    },
    methods: {
        iceCallback(event){
            if(event.candidate){
              console.log("******* new ice candidate *****")
              SignalingServer.AnswerICE(this.loggedInUserId,
                                        event.candidate,
                                        [this.callFromUserId])
            }
          },
          iceCandidateError(e){
              console.log('The server ' + e.url +
              ' returned an error with code=' + e.errorCode + ':\n' +
              e.errorText + '\n')
          },
          RTCStatus(){
            if(typeof this.pc_rec != "undefined"){
              if(this.pc_rec.iceConnectionState == "connected" && this.callTime == 0){
                this.calculateCallTime()
              }

              if(this.pc_rec.iceConnectionState == "connected"){
                if(this.joinedAtTime == 0){
                  this.sinceNotify = (new Date().getTime() - this.NotifyJoinCallTime)/1000;
                  this.joinedAtTime = (new Date().getTime() - this.startMountTime)/1000;
                }

                console.log("need to join ", this.sinceNotify)
                console.log("need to join ", this.joinedAtTime)
                Global.globalValue("ongoing_channel_call_id", "")
                Global.globalValue("reconnecting_leader", false)
              }



              if(this.pc_rec.iceConnectionState == "disconnected"){
                Global.globalValue("inCall", false)
                this.calleeAudio.pause()
              }

              if(this.pc_rec.iceConnectionState == "failed"){
                  this.pc_rec.restartIce()
                  // this.pc_rec.close()
                  let rtcICE =  {"event":"SOCKET_ICE_ERROR",
                    "creator_user_id": this.loggedInUserId,
                    "channel_id": this.callChannelId,
                    "broadcast": {
                      "user_ids": [this.callFromUserId],
                  }}
                  Socket.push(rtcICE)
              }

              console.log("RTC Connection Send status ----> " + this.pc_rec.iceConnectionState)
              console.log("RTC Signal status ----> " +          this.pc_rec.signalingState)
              console.log("RTC gathering Send status ----> " +  this.pc_rec.iceGatheringState)
            }
          },
          AcceptCall(){
            // if(this.localAudioStream == null){
            //     Global.globalValue("rtc_call_banner_message_red", "Please, Install a camera or if it's already installed allow it")
            //   return
            // }
            this.calleeAudio.pause()
            Global.globalValue("SHOW_CONFERENCE", true)
            Global.globalValue("SHOW_CONFERENCE_CHANNEL", this.callChannelId)
            Global.globalValue("CALL_INIT_USER_ID", this.callFromUserId)
            Global.globalValue("RTC_Call", true)
            Global.globalValue(VueSignals.SHOW_RIGHT_SIDEBAR_MOBILE, true)
            Global.globalValue(VueSignals.RIGHT_SIDEBAR_COLLAPSED, false)
            Global.globalValue(VueSignals.RIGHT_SIDEBAR_THEME,'conference')
            this.callState = 'accepted'
            this.pc_rec.onicecandidate = this.iceCallback
            this.pc_rec.oniceconnectionstatechange =  this.RTCStatus
            this.pc_rec.onicegatheringstatechange =  this.RTCStatus
            this.pc_rec.onicecandidateerror = this.iceCandidateError
            Global.globalValue("callInitUserId", this.callFromUserId)
            Global.globalValue("inCall", true)

            this.pc_rec.createAnswer().then( answer => {

              SignalingServer.AnswerCall(this.loggedInUserId,
                                    answer,
                                    false,
                                    [this.callFromUserId])
              this.pc_rec.setLocalDescription(new RTCSessionDescription(answer))
              if(this.callChannelId){
                ChannelApi.join_call(this.callChannelId).then(res=> {
                  if(!res.data.result){
                    Global.globalValue("rtc_call_banner_message_red", res.data.reason)
                  }
                })
              }

              }).catch(err => {
                console.log(err)
              })
          },
          DeclineCall(){
            ChannelApi.declineCall(this.callChannelId)
            this.calleeAudio.pause()
            if(this.pc_rec != null){
              this.pc_rec.close()
            }
            this.CloseAllTracks()
            this.callState = 'declined'
            SignalingServer.DeclineCall(this.loggedInUserId,
                                        [this.callFromUserId])
            Global.globalValue("SHOW_CONFERENCE", false)
            Global.globalValue(VueSignals.RIGHT_SIDEBAR_THEME,'channel_users')
            Global.globalValue("CALL_REMOVE_USER", this.loggedInUserId)
            Global.globalValue("inCall", false)
            this.ResetCallData()
            Global.globalValue("RTC_Call", false)
          },
          track(e, user_id){
            console.log("********** remote track *******")
            console.log(e)
            console.log(e.streams)
            console.log("track", SessionManager.getUser(user_id).username)
            console.log("track", user_id)


            Global.globalValue("CALL_GOT_USER", {
              "user_id": user_id,
              "streamEvent":e
            })

          },
          screenshare(){
            if(this.localVideoStream != null && this.localVideoStreamType == 'screenshare'){
              this.localVideoStreamType = ''
              this.localVideoStream.getTracks().forEach(function(track) {
                  track.stop();
              })
              SignalingServer.DisableVideo(this.loggedInUserId, true, this.callUserIds)
              this.localVideoStream = null
              return
            }
            this.localVideoStreamType = 'screenshare'
            // this.localVideoStream is empty and request screen share
            if(this.isELectron){
              if(!allowVideo){
                navigator.webkitGetUserMedia({
                  audio:false,
                  video: {
                      mandatory:{
                          chromeMediaSource: 'desktop'
                      }
                  }
              }, (gotStream) => {
                this.allowVideo = true
                  let stream
                  if(typeof gotStream.streams == "undefined"){
                      stream = gotStream
                      stream.streams = [gotStream]
                  }
                  // console.log("call", stream)
                  this.localVideoStream = stream
                  this.addStream(stream, this.loggedInUserId)
                  Global.globalValue("CALL_GOT_USER", {
                      "user_id": this.loggedInUserId,
                      "streamEvent":stream
                  })
                  document.querySelector("#video_from_" + this.loggedInUserId).src = URL.createObjectURL(stream)
                  SignalingServer.DisableVideo(this.loggedInUserId, !this.allowVideo, this.callUserIds)

                  }, (err) => {
                      console.log(err)
                  })
              }else {
                Global.globalValue("CALL_GOT_USER", {
                  "user_id": this.loggedInUserId,
                    "streamEvent":null
                })
                this.allowVideo = false
                if(this.localVideoStream != null){
                  this.localVideoStream.getTracks().forEach(track => {
                    // this.pc_rec.addTrack(track, this.localVideoStream)
                    track.stop();
                  })
                }
                SignalingServer.DisableVideo(this.loggedInUserId, !this.allowVideo, this.callUserIds)

              }
                return
            }
            if (navigator.getDisplayMedia) {
              this.getRootWindow(window).navigator.getDisplayMedia({video: true}).then(stream => {
                  this.addStream(stream)
                  Global.globalValue("shareLocalVideoStream", this.localVideoStream)
                });
            } else if (navigator.mediaDevices.getDisplayMedia) {
              this.getRootWindow(window).navigator.mediaDevices.getDisplayMedia({video: true}).then(stream => {
                  this.addStream(stream)
                  Global.globalValue("shareLocalVideoStream", this.localVideoStream)
                });
            } else {
              this.getRootWindow(window).navigator.mediaDevices.getUserMedia({ video: {mediaSource: 'screen'}}).then(stream => {
                  this.addStream(stream)
                  Global.globalValue("shareLocalVideoStream", this.localVideoStream)
                });
            }
            this.callUserIds.push(this.callFromUserId)
            SignalingServer.DisableVideo(this.loggedInUserId, !this.allowVideo, this.callUserIds)
        },
        videoCall(){
             if(!this.allowVideo){
              this.getRootWindow(window).navigator.mediaDevices.getUserMedia({video: true}).then(stream => {
                  this.localVideoStream = stream
                    Global.globalValue("CALL_GOT_USER", {
                        "user_id": this.loggedInUserId,
                        "streamEvent":stream
                    })
                    Global.globalValue("shareLocalVideoStream", this.localVideoStream)
                    this.addStream(stream)
                    this.allowVideo = true
                }).catch((error) => {
                  Global.globalValue("rtc_call_banner_message_red", "Please, Install a camera or if it's already installed allow it")
                  console.error(error)
                })
            }else {
                Global.globalValue("CALL_GOT_USER", {
                    "user_id": this.loggedInUserId,
                    "streamEvent":null
                })
                this.allowVideo = false
                if(this.localVideoStream != null){
                  this.localVideoStream.getTracks().forEach(track => {
                    // this.pc_rec.addTrack(track, this.localVideoStream)
                    track.stop();
                  })
                }
            }
            this.callUserIds.push(this.callFromUserId)
            SignalingServer.DisableVideo(this.loggedInUserId, !this.allowVideo, this.callUserIds)
      },
      microphoneClick(){
        if(!this.microphoneMuted){
          this.microphoneMuted = true
          this.localAudioStream.getTracks().forEach(function(track){
              track.stop()
          })
          this.callUserIds.push(this.callFromUserId)
          SignalingServer.DisableAudio(this.loggedInUserId, this.microphoneMuted, this.callUserIds)
        }else {
          try {
            this.getRootWindow(window).navigator.mediaDevices.getUserMedia({audio: true}).then(stream => {
                this.localAudioStream = stream
                Global.globalValue("CALL_GOT_USER", {
                    "user_id": this.loggedInUserId,
                    "streamEvent":stream
                })
                this.microphoneMuted = false
                this.callUserIds.push(this.callFromUserId)
                SignalingServer.DisableAudio(this.loggedInUserId, this.microphoneMuted, this.callUserIds)
                this.addStream(stream, this.loggedInUserId)
            });
          } catch (error) {
              console.error(error)
          }
          // this.RequestMicrophone()
        }
      },
      pad ( val ) { return val > 9 ? val : "0" + val; },
      calculateCallTime() {
        this.elapsedTime = this.pad(parseInt(this.callTime/60,10)) // min
        this.elapsedTime += ":"
        this.elapsedTime +=  this.pad(++this.callTime%60)        // sec
        setTimeout( function(){
          Global.globalValue("calculateCallTime", true)
        }, 1000);
      },
      addStream(gotStream){
        if(gotStream.getTracks()[0].kind == "video"){
          this.localVideoStream = gotStream
        }

        try {
          gotStream.getTracks().forEach(track => {
            this.pc_rec.addTrack(track, gotStream)
          })
        } catch (error) {
          console.error(error)
        }

        Global.globalValue("CALL_GOT_USER", {
          "user_id": this.loggedInUserId,
          "streamEvent":gotStream
        })


        this.pc_rec.createOffer().then((desc) => {
          SignalingServer.UpgradeOfferCalle(this.loggedInUserId,
                                            desc,
                                            [this.callFromUserId])
          this.pc_rec.setLocalDescription(new RTCSessionDescription(desc))
        })
      },
      RequestMicrophone(){
        this.getRootWindow(window).navigator.mediaDevices.getUserMedia({audio: true}).then(stream => {
            this.localAudioStream = stream
              Global.globalValue("CALL_GOT_USER", {
                "user_id": this.loggedInUserId,
                "streamEvent":stream
              })

              Global.globalValue("shareLocalAudioStream", this.localAudioStream)
              if(this.automaticAnswer || this.fromJoin){
                this.AcceptCall()
              }

              if (this.localAudioStream != null){
                  this.localAudioStream.getTracks().forEach(track => {
                  this.pc_rec.addTrack(track, this.localAudioStream)
                })
              }

              if(this.localVideoStream != null){
                this.localVideoStream.getTracks().forEach(track => {
                  this.pc_rec.addTrack(track, this.localVideoStream)
                })
              }
          }).catch((error) => {
            Global.globalValue("rtc_call_banner_message_red", "Please, Install a microphone or if it's already installed allow it")
            console.error(error)
          })

      },
      CloseAllTracks(){
        if(this.localAudioStream){
          this.localAudioStream.getTracks().forEach((track) => {
            track.stop()
          })
        }
        if(this.localVideoStream){
            this.localVideoStream.getTracks().forEach((track) => {
              track.stop()
            })
        }
      },
      ResetCallData(){
        this.callFromUserId = ''
        this.CallingUser = null
        this.callState = 'none'
        this.callChannelId = ''
        this.callTime = 0
        this.elapsedTime = "00:00"
        this.automaticAnswer =  false
        this.callerUserId =  ""
        this.microphoneMuted = false
        this.allowVideo =  false
        this.reconnected = false
        this.leaderPointer =  0
        this.localAudioStream =  null
        this.localVideoStream =  null
        this.fromJoin =  false
      },
      getRootWindow(window){
        if(window.parent === window){
            return window
        }
        return this.getRootWindow(window.parent)
      },
    }

}
